import { TRANSPORTATION_ORIGIN } from '~config/publicEnv';
import { MemberHashResponse } from '~models/ChannelTalkDto';
import { HttpClient, RequestParams } from '~utils/https/HttpClientFetch';

/**
 * @title ChannelTalk API
 * @baseUrl https://www.myrealtrip.com/transportation/api/channel-talk
 *
 */
class ChannelTalkApi<SecurityDataType> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description userId 기반의 memberHash를 반환받습니다.
     *
     * @tags front-channelTalk-controller
     * @name member-hash
     * @summary memberHash 취득 API
     * @request GET:/channel-talk/member-hash
     */
    memberHash: (params: RequestParams = {}) =>
      this.request<MemberHashResponse>({
        path: `/member-hash`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}

const channelTalkApi = new ChannelTalkApi({
  baseURL: `${TRANSPORTATION_ORIGIN}/api/channel-talk`,
  secureWorker(securityData) {
    return {
      headers: {
        Authorization: `Bearer ${securityData}`,
      },
    };
  },
  secure: false,
});

export { channelTalkApi };
